import { render, staticRenderFns } from "./PartSoundForm.vue?vue&type=template&id=c747ee5a&scoped=true"
import script from "./PartSoundForm.vue?vue&type=script&lang=js"
export * from "./PartSoundForm.vue?vue&type=script&lang=js"
import style0 from "./PartSoundForm.vue?vue&type=style&index=0&id=c747ee5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c747ee5a",
  null
  
)

export default component.exports